/* src/app/views/display/components/edit-display/edit-display-menu-details/edit-display-menu-details-action/edit-display-menu-details-action.component.scss */
/*# sourceMappingURL=edit-display-menu-details-action.component.css.map */
